import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Input, Spin, Empty, Tag, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ShoppingCartOutlined, FireOutlined, SearchOutlined } from '@ant-design/icons';
import { productAPI } from '../utils/api';
import './Home.css';

const { Search } = Input;
const { Meta } = Card;

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const products = await productAPI.getList(true);
      setProducts(products);
    } catch (error) {
      message.error('加载商品失败');
    } finally {
      setLoading(false);
    }
  };

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchText.toLowerCase()) ||
    (product.description && product.description.toLowerCase().includes(searchText.toLowerCase()))
  );

  return (
    <div className="home-page">
      <div className="banner">
        <h1><FireOutlined /> 欢迎来到发卡网</h1>
        <p>安全快捷的自动发卡平台，支付成功立即发货</p>
      </div>

      <div className="search-section">
        <Search
          placeholder="搜索商品..."
          size="large"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ maxWidth: 600 }}
        />
      </div>

      <div className="products-section">
        <h2 className="section-title">
          <ShoppingCartOutlined /> 商品列表
        </h2>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px 0' }}>
            <Spin size="large" />
          </div>
        ) : filteredProducts.length === 0 ? (
          <Empty description="暂无商品" />
        ) : (
          <Row gutter={[16, 16]}>
            {filteredProducts.map(product => (
              <Col xs={24} sm={12} md={8} lg={6} key={product.id}>
                <Card
                  hoverable
                  cover={
                    <div className="product-image">
                      {product.image ? (
                        <img alt={product.name} src={product.image} />
                      ) : (
                        <div className="no-image">
                          <ShoppingCartOutlined style={{ fontSize: 48 }} />
                        </div>
                      )}
                    </div>
                  }
                  onClick={() => navigate(`/product/${product.id}`)}
                >
                  <Meta
                    title={product.name}
                    description={
                      <div>
                        <p className="product-desc">{product.description}</p>
                        <div className="product-footer">
                          <span className="price">¥{product.price}</span>
                          <Tag color={product.stock > 0 ? 'success' : 'error'}>
                            库存: {product.stock}
                          </Tag>
                        </div>
                        {product.soldCount > 0 && (
                          <div style={{ marginTop: 8 }}>
                            <Tag color="blue">已售 {product.soldCount}</Tag>
                          </div>
                        )}
                      </div>
                    }
                  />
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
};

export default Home;
